import {
  CheckCircleFilled,
  FilterOutlined,
  PlusOutlined,
  WarningOutlined,
  UndoOutlined,
  TableOutlined,
  ApartmentOutlined,
  ArrowUpOutlined,
  ArrowDownOutlined,
  GroupOutlined,
  NodeIndexOutlined,

} from "@ant-design/icons";
import { Tooltip, Button, Badge, Input, Select, Form, Modal } from "antd";
import { Content } from "antd/lib/layout/layout";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import GetFilteredTopPlansApi from "../../api/GetFilteredTopPlansApi";
import GetTopPlansApi from "../../api/GetTopPlansApi";
import GetHeadLevelPlanApi from "../../api/plans/GetHeadLevelPlanApi";
import GetGlobalSettingsApi from "../../api/global-settings/GetGlobalSettingsApi";
import DashboardBreadcrumb from "../../components/layout/DashboardBreadcrumb";
import AddTopPlanModal from "../../components/modal/add/AddTopPlanModal";
import TopPlanFilterModal from "../../components/modal/filters/TopPlanFilterModal";
import PageLoader from "../../components/sub/PageLoader";
import TopPlanTreeCards from "../../components/TopPlanTreeCards";
import StrategyGroupedPlanCards from "../../components/StrategyGroupedPlanCards";
import GroupedPlans from "../../components/GroupedPlans";
import PlansTree from "../../components/tree/PlansTree";
import FullTreeViewMock from "../../components/tree/FullTreeViewMock";
import { useGlobalSettings } from "../../context/GlobalSettingsContext";

import { permissionAbility } from "../../helpers/permissionHelpers";
import { getPluralString } from "../../helpers/wordHelpers";
import { LIMIT_PER_PAGE } from "../../helpers/constants";

const { Option } = Select;

function TopPlans() {
  const [canStart, setCanStart] = useState(false);
  const [canShow, setCanShow] = useState(false);
  const [table, setTable] = useState(true);
  const [strategyGrouped, setStrategyGrouped] = useState(false);
  const [planGroupGrouped, setPlanGroupGrouped] = useState(true);
  const [fullTreeView, setFullTreeView] = useState(false);

  const [treePlans, setTreePlans] = useState([]);
  const [data, setData] = useState([]);
  const [planGroupProgress, setPlanGroupProgress] = useState({});
  const [totalTopPlanCount, setTotalTopPlanCount] = useState(0);
  const [startAt, setStartAt] = useState(0);
  const [addModal, setAddModal] = useState(false);
  const [filterModal, setFilterModal] = useState(false);
  const [filterStatus, setFilterStatus] = useState(false);
  const [tableLoading, setTableLoading] = useState(false);
  const [filterBy, setFilterBy] = useState();
  const [headLevel, setHeadLevel] = useState("");
  const [sort, setSort] = useState("ASC");
  const perfCycleState = useSelector((state) => state.perfCycleState.value);
  const topPlanState = useSelector((state) => state.topPlanState.value);
  const proHeight = document.body.clientHeight;
  const positionState = useSelector((state) => state.positionState.value);
  const userLevel = positionState?.userRole?.name;

  let curLocation = useLocation();

  let path = curLocation.search;
  let hasPlanGroup = path.split("/top-plans");
  const searchParams = new URLSearchParams(curLocation.search);
  let filterFromGraph = {
    planGroup: searchParams.get("planGroup"),
  };

  useEffect(() => {
    getHeadLevelPlan();
    if (hasPlanGroup[0]?.slice(1, 10) === "planGroup") {
      getFilteredPlans(
        filterFromGraph,
        0,
        false,
        localStorage.getItem("sorting")
      );
    } else {
      getTopPlans(startAt, false, localStorage.getItem("sorting"));
    }
    setSort(localStorage.getItem("sorting"));
  }, [perfCycleState]);

  async function getTopPlans(num, newSet, sorting) {
    setTableLoading(true);
    const apiResponse = await GetTopPlansApi(
      perfCycleState.id,
      positionState.id,
      num,
      sorting,
      LIMIT_PER_PAGE
    );
    if (apiResponse.success) {
      if (apiResponse.data?.plans) {
        if (newSet) {
          setData(apiResponse.data?.plans);
          // Store plan group progress data from API response
          if (apiResponse.data?.planGroupProgress) {
            setPlanGroupProgress(apiResponse.data.planGroupProgress);
          }
        } else {
          setData([...data, ...apiResponse.data?.plans]);
          // Update plan group progress data for additional data
          if (apiResponse.data?.planGroupProgress) {
            setPlanGroupProgress(prev => ({
              ...prev,
              ...apiResponse.data.planGroupProgress
            }));
          }
        }
        setTable(true);
        if (apiResponse.data?.plans?.length !== 0) {
          setCanShow(true);
        }

        setTableLoading(false);
        setTotalTopPlanCount(apiResponse.data?.totalCount);
      }
      setCanStart(true);
    }
  }

  async function getFilteredPlans(values, num, newSet, sorting) {
    setTableLoading(true);
    const apiResponse = await GetFilteredTopPlansApi(
      positionState.id,
      perfCycleState.id,
      values.title || "",
      values.planGroup || "",
      values.cascadeFrom || "",
      num,
      LIMIT_PER_PAGE,
      sorting
    );
    if (apiResponse.success) {
      setFilterStatus(true);
      if (newSet) {
        setData(apiResponse.data?.plans);
        // Store plan group progress data from API response
        if (apiResponse.data?.planGroupProgress) {
          setPlanGroupProgress(apiResponse.data.planGroupProgress);
        }
      } else {
        setData([...data, ...apiResponse.data?.plans]);
        // Update plan group progress data for additional data
        if (apiResponse.data?.planGroupProgress) {
          setPlanGroupProgress(prev => ({
            ...prev,
            ...apiResponse.data.planGroupProgress
          }));
        }
      }
      setTotalTopPlanCount(apiResponse.data?.totalCount);
      setTableLoading(false);
      setFilterBy({
        title: values.title,
        planGroup: values.planGroup,
        cascadeFrom: values.cascadeFrom,
      });
      if (apiResponse.data?.plans?.length !== 0) {
        setTable(true);
        setCanShow(true);
      }

      setCanStart(true);
    }
  }

  function loadMore(num) {
    if (filterStatus) {
      getFilteredPlans(filterBy, num, false, localStorage.getItem("sorting"));
    } else {
      getTopPlans(num, false, localStorage.getItem("sorting"));
    }
  }

  function changeSorting(type) {
    localStorage.setItem("sorting", type);
    setSort(type);
    if (filterStatus) {
      getFilteredPlans(filterBy, 0, true, localStorage.getItem("sorting"));
    } else {
      getTopPlans(0, true, type);
    }
  }

  function handleDelete(planId) {
    setTotalTopPlanCount(totalTopPlanCount - 1);
    const newData = [];
    data.forEach((element) => {
      if (planId !== element.planId) {
        newData.push(element);
      }
    });
    setData(newData);
    if (totalTopPlanCount - 1 === 0) {
      setCanShow(false);
    }
  }

  function handleEdit(editedPlan) {
    // Reload the entire list to get fresh data with updated isActive status
    if (filterStatus) {
      getFilteredPlans(filterBy, 0, true, localStorage.getItem("sorting"));
    } else {
      getTopPlans(0, true, localStorage.getItem("sorting"));
    }
  }

  function resetFilter() {
    setData([]);
    setFilterStatus(false);

    getTopPlans(0, true, localStorage.getItem("sorting"));
    setFilterBy();
  }

  async function getHeadLevelPlan() {
    const apiResponse = await GetHeadLevelPlanApi(
      perfCycleState.id,
      positionState.id
    );
    if (apiResponse.success) {
      setTreePlans(apiResponse.data);
      if (apiResponse.data?.length !== 0) {
        setCanShow(true);
      }

      setTableLoading(false);
    }
  }

  const right = table && (
    <>
      {sort === "DESC" ? (
        <Tooltip title={"Change order"}>
          <Button onClick={() => changeSorting("ASC")} className="mr-3">
            <ArrowDownOutlined />
          </Button>
        </Tooltip>
      ) : (
        <Tooltip title={"Change order"}>
          <Button onClick={() => changeSorting("DESC")} className="mr-3">
            <ArrowUpOutlined />
          </Button>
        </Tooltip>
      )}
      {canShow && (
        <>
          <Tooltip title={"Group by Plan Group"}>
            <Button
              type={planGroupGrouped ? "primary" : "default"}
              onClick={() => {
                setPlanGroupGrouped(!planGroupGrouped);
                setStrategyGrouped(false); // Disable strategy grouping when plan group grouping is enabled
              }}
              className="mr-3"
            >
              <GroupOutlined />
            </Button>
          </Tooltip>
          <Tooltip title={"Reset"}>
            <Button
              disabled={!filterStatus}
              onClick={() => {
                resetFilter();
              }}
              className="mr-3"
            >
              <UndoOutlined />
            </Button>
          </Tooltip>
          <Tooltip title={"Filter"}>
            <Badge
              count={
                filterStatus ? (
                  <CheckCircleFilled style={{ color: "#f5222d" }} />
                ) : (
                  0
                )
              }
            >
              <Button onClick={() => setFilterModal(true)}>
                <FilterOutlined />
              </Button>
            </Badge>
          </Tooltip>
        </>
      )}
      {permissionAbility(userLevel, "plans", "add") && (
        <Tooltip placement="left" title={`Add ${topPlanState}`}>
          <Button
            className="ml-3"
            onClick={() => {
              setAddModal(true);
            }}
            shape="circle"
            type="primary"
            icon={<PlusOutlined />}
          ></Button>
        </Tooltip>
      )}
    </>
  );

  const [cycleFinalized, setCycleFinalized] = useState(false);

  // Global feature settings from context (set once at app level)
  const globalSettings = useGlobalSettings();

  const handleCycleFinalizedToggle = () => {
    Modal.confirm({
      title: 'Finalize Performance Cycle',
      content: 'Do you want to finalize this performance cycle?',
      okText: 'Yes',
      cancelText: 'No',
      onOk() {
        setCycleFinalized(!cycleFinalized);
        // This is purely cosmetic for now - no API call needed
      },
      onCancel() {
        // Do nothing
      },
    });
  };

  const left = (
    <>
      <div className="pri-font text-lg">{getPluralString(topPlanState)}</div>
      {canShow &&
        (table ? (
          <>
            {globalSettings.treeView && (
              <Tooltip title={"Tree view"}>
                <Button onClick={() => {setTable(false); setFullTreeView(false);}} className="ml-3">
                  <ApartmentOutlined />
                </Button>
              </Tooltip>
            )}
            {globalSettings.fullTreeView && (
              <Tooltip title={"Full Tree view"}>
                <Button
                  type={fullTreeView ? "primary" : "default"}
                  onClick={() => {setTable(false); setFullTreeView(true);}}
                  className="ml-3"
                >
                  <NodeIndexOutlined />
                </Button>
              </Tooltip>
            )}
          </>
        ) : fullTreeView ? (
          <>
            <Tooltip title={"Table view"}>
              <Button onClick={() => {setTable(true); setFullTreeView(false);}} className="ml-3">
                <TableOutlined />
              </Button>
            </Tooltip>
            {globalSettings.treeView && (
              <Tooltip title={"Tree view"}>
                <Button onClick={() => setFullTreeView(false)} className="ml-3">
                  <ApartmentOutlined />
                </Button>
              </Tooltip>
            )}
          </>
        ) : (
          <>
            <Tooltip title={"Table view"}>
              <Button onClick={() => {setTable(true); setFullTreeView(false);}} className="ml-3">
                <TableOutlined />
              </Button>
            </Tooltip>
            {globalSettings.fullTreeView && (
              <Tooltip title={"Full Tree view"}>
                <Button onClick={() => setFullTreeView(true)} className="ml-3">
                  <NodeIndexOutlined />
                </Button>
              </Tooltip>
            )}
          </>
        ))}
      {/* Performance Cycle Name Display */}
      {perfCycleState && (
        <div className="flex items-center ml-4">
          <div className="flex items-center">
            <div 
              className="relative inline-flex items-center cursor-pointer hover:opacity-80 transition-opacity"
              onClick={handleCycleFinalizedToggle}
              title={cycleFinalized ? "Performance Cycle Finalized" : "Performance Cycle Not Finalized"}
            >
              <span 
                className="font-medium text-gray-900 px-3 py-1 rounded-full border-2 transition-all duration-200"
                style={{
                  backgroundColor: cycleFinalized ? '#90EE90' : '#F3F4F6',
                  borderColor: cycleFinalized ? '#90EE90' : '#D1D5DB',
                  color: cycleFinalized ? '#006400' : '#374151'
                }}
              >
                {perfCycleState.name}
              </span>
            </div>
            {cycleFinalized && (
              <CheckCircleFilled 
                style={{ 
                  color: '#006400', 
                  fontSize: '16px',
                  marginLeft: '8px'
                }} 
                title="Performance Cycle Finalized"
              />
            )}
          </div>
        </div>
      )}
    </>
  );

  function showEmptyFilter() {
    return (
      <div className="flex justify-center items-center w-full h-full py-10">
        <div className="text-center">
          <div className="text-3xl text-gray-400">
            <WarningOutlined />
          </div>
          <div className="text-lg pri-font text-gray-400">
            No {getPluralString(topPlanState)} available for the filter
          </div>
        </div>
      </div>
    );
  }

  function showEmptyCompanies() {
    return (
      <div className="flex justify-center items-center w-full h-full">
        <div className="text-center">
          <div className="text-3xl text-gray-400">
            <WarningOutlined />
          </div>
          <div className="text-xl pri-font text-gray-400">
            No {getPluralString(topPlanState)} available
          </div>

          {permissionAbility(userLevel, "plans", "add") && (
            <>
              <div className="mb-3 text-gray-400">
                Add {getPluralString(topPlanState)} in your organization
              </div>
              <Button
                onClick={() => {
                  setAddModal(true);
                }}
                type="primary"
              >
                Add a {topPlanState}
              </Button>
            </>
          )}
        </div>
      </div>
    );
  }

  function renderTreeView() {
    return (
      <>
        {canShow ? (
          treePlans.length ? (
            <>
              <div className="mb-3">
                <Select
                  showSearch
                  placeholder="Select head level plan"
                  optionFilterProp="children"
                  filterOption={(input, option) =>
                    option.children
                      .toLowerCase()
                      .indexOf(input.toLowerCase()) >= 0
                  }
                  filterSort={(optionA, optionB) =>
                    optionA.children
                      .toLowerCase()
                      .localeCompare(optionB.children.toLowerCase())
                  }
                  defaultValue={() => setHeadLevel(treePlans[0]?.id)}
                  onSelect={(value) => setHeadLevel(value)}
                  className={"w-full max-w-md"}
                >
                  {treePlans?.map((head) => {
                    return (
                      <Option key={head?.id} value={head?.id}>
                        {head.name}
                      </Option>
                    );
                  })}
                </Select>
              </div>
              <PlansTree plan={headLevel} />
            </>
          ) : (
            <div className="flex justify-center items-center w-full h-full">
              <div className="text-center">
                <div className="text-3xl text-gray-400">
                  <WarningOutlined />
                </div>
                <div className="text-xl pri-font text-gray-400">
                  No hierarchy available
                </div>
              </div>
            </div>
          )
        ) : (
          <div
            style={{
              height: proHeight - 188,
            }}
          >
            <PageLoader />
          </div>
        )}
      </>
    );
  }

  return (
    <>
      <Content style={{ backgroundColor: "#fff" }}>
        <DashboardBreadcrumb left={left} right={right} />
        <div
          style={{
            height: proHeight - 122,
            overflow: "auto",
          }}
          className="custom-scroll p-6"
        >
          {canStart ? (
            canShow ? (
              table ? (
                <div className="mb-5">
                  {planGroupGrouped ? (
                    <GroupedPlans
                      data={data}
                      planGroupProgress={planGroupProgress}
                      setStartAt={(num) => setStartAt(num)}
                      loadMore={(num) => loadMore(num)}
                      loading={tableLoading}
                      startAt={startAt}
                      totalTopPlanCount={totalTopPlanCount}
                      handleDelete={(planId) => handleDelete(planId)}
                      handleEdit={(editedPlan) => handleEdit(editedPlan)}
                    />
                  ) : strategyGrouped ? (
                    <StrategyGroupedPlanCards
                      data={data}
                      setStartAt={(num) => setStartAt(num)}
                      loadMore={(num) => loadMore(num)}
                      loading={tableLoading}
                      startAt={startAt}
                      totalTopPlanCount={totalTopPlanCount}
                      handleDelete={(planId) => handleDelete(planId)}
                      handleEdit={(editedPlan) => handleEdit(editedPlan)}
                    />
                  ) : (
                    <TopPlanTreeCards
                      data={data}
                      setStartAt={(num) => setStartAt(num)}
                      loadMore={(num) => loadMore(num)}
                      loading={tableLoading}
                      startAt={startAt}
                      totalTopPlanCount={totalTopPlanCount}
                      handleDelete={(planId) => handleDelete(planId)}
                      handleEdit={(editedPlan) => handleEdit(editedPlan)}
                    />
                  )}
                  {data?.length === 0 && !tableLoading && showEmptyFilter()}
                </div>
              ) : fullTreeView ? (
                <FullTreeViewMock />
              ) : (
                renderTreeView()
              )
            ) : (
              showEmptyCompanies()
            )
          ) : (
            <PageLoader />
          )}
        </div>
      </Content>
      <AddTopPlanModal
        visible={addModal}
        handleCancel={() => {
          setAddModal(false);
        }}
        handleOk={(values) => {
          const newData = data;
          newData.unshift(values);
          setData(newData);
          setStartAt(startAt + 1);

          totalTopPlanCount === 0 && setCanShow(true);
          setTotalTopPlanCount(totalTopPlanCount + 1);
        }}
      />
      <TopPlanFilterModal
        visible={filterModal}
        handleCancel={() => setFilterModal(false)}
        handleOk={(values) => {
          setCanStart(false);
          getFilteredPlans(values, 0, true, localStorage.getItem("sorting"));
        }}
        filterBy={filterBy}
      />
    </>
  );
}

export default TopPlans;
